import type { OrderProgressBarProps } from './OrderProgressBar.types';
import './OrderProgressBar.scss';

export default function OrderProgressBar({
  value, max = 100, label, showValue, className,
}: OrderProgressBarProps) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div className={['order-progress', className || ''].filter(Boolean).join(' ')}>
      {label || showValue ? (
        <div className="order-progress__head">
          {label ? <span className="order-progress__label">{label}</span> : <span />}
          {showValue ? <span className="order-progress__value">{Math.round(pct)}%</span> : null}
        </div>
      ) : null}
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={max}
        aria-valuenow={value}
        aria-label={label}
        className="order-progress__track"
      >
        <span className="order-progress__bar" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
